<template>
<div>
    <QuillInputS
        v-if="editing"
        name="body"
        display-name=""
        placeholder="Body here"
        :value="component.quill"
        @quillChanged="quillChanged"
    ></QuillInputS>
    <div v-else>
        {{textOnly(component.html)}}
    </div>
</div>
</template>

<script>
import QuillInputS from './../QuillInputS'

export default {
    components: {
        QuillInputS,
    },
    props: [
        'component',
        'editing',
    ],
    data(){return {
    }},
    methods: {
        quillChanged(html, quill){
            this.$emit('quillChanged', html, quill)
        },
        textOnly(text) {
            return text
                .replace(/<[^>]+>/g, ' ')
                .replace(/\s+/g, ' ')
                .trim()
                .substr(0, 200)
        },
    },
}
</script>